<template>
	<div>

		<post-smtp-widget
			v-if="!isMobileAppConfigured"
			class="mobile-wrapper"
		>
	
			<h3 class="mobile-header">
				{{ i18n.mobileApp.title }}
				<br>
				<strong>{{ i18n.mobileApp.subTitle }}</strong>
			</h3>

			<ul class="mobile-unstyles-list">
				<li>{{ i18n.mobileApp.list[0] }}</li>
				<li>{{ i18n.mobileApp.list[1] }}</li>
				<li>{{ i18n.mobileApp.list[2] }}</li>
			</ul>
			<div class="img-wrapper">
				<post-smtp-img class="qrcode-img" :src="plugin_dir_url + 'assets/images/qrcode.png'" />
				<post-smtp-img class="qrcode-mobile-app" :src="plugin_dir_url + 'assets/images/mobile-app.svg'" />
			</div>
		</post-smtp-widget>

		<post-smtp-widget
			v-else-if="!isMainWpConfigured"
			class="post-smtp-main-wp-wrapper"
		>
			<div class="main-wp-header">
				<h3>
					{{ i18n.mainWP.title }}
					<span>{{ i18n.mainWP.subTitle }}</span>
				</h3>
			</div>

			<ul class="main-wp-unstyled-list">
				<li>{{ i18n.mainWP.list[0] }}</li>
				<li>{{ i18n.mainWP.list[1] }}</li>
				<li>{{ i18n.mainWP.list[2] }}</li>
				<li>{{ i18n.mainWP.list[3] }}</li>
				<li>{{ i18n.mainWP.list[4] }}</li>
			</ul>

			<div class="main-wp-footer">
				<a href="https://postmansmtp.com/mainwp-post-smtp/?utm_source=plugin&utm_medium=mainwp_banner&utm_campaign=plugin">
					{{ i18n.mainWP.link }}
				</a>
			</div>
		</post-smtp-widget>

		<post-smtp-widget
			v-else-if="!isDomainSpamScoreConfigured"
			class="post-smtp-spam-score-wrapper"
		>
			<div>
				<div class="post-smtp-spam-score-header">
					<h2>
						{{ i18n.spamScore.title }}
						<br>
						<b>{{ i18n.spamScore.subTitle }}</b>
					</h2>
				</div>
				<ul class="post-smtp-spam-score-list-unstyled">
					<li>{{ i18n.spamScore.list[0] }}</li>
					<li>{{ i18n.spamScore.list[1] }}</li>
					<li>{{ i18n.spamScore.list[2] }}</li>
					<li>{{ i18n.spamScore.list[3] }}</li>
					<li>{{ i18n.spamScore.list[4] }}</li>
				</ul>
				<div class="post-smtp-spam-score-footer">
					<a href="https://postmansmtp.com/domain-health-checker/?utm_source=plugin&utm_medium=dashboard_banner&utm_campaign=plugin">{{ i18n.spamScore.link }}</a>
				</div>
			</div>
		</post-smtp-widget>

	</div>
</template>

<script>

export default {
	name: 'PostSmtpAds',

	props: {
		postSmtpPro           : {
			type: Boolean,
			default: false,
		},
		isMobileAppConfigured : {
			type: Boolean,
			default: false,
		},
		isMainWpConfigured : {
			type: Boolean,
			default: false,
		},
		isDomainSpamScoreConfigured : {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.ads,
	} ),
}
</script>

<style scoped>
.mobile-wrapper {
	background: linear-gradient(180deg, #FFFFFF 50%, #DCE7FF 100%);
}

.mobile-wrapper * {
	padding: 0;
	margin: 0;
}

.mobile-header {
	font-family: Montserrat;
	font-size: 14px;
	font-weight: 500;
	line-height: 17.5px;
	text-align: left;
	color: #375CAF;
}

.mobile-header strong {
	font-family: Montserrat;
	font-size: 14px;
	font-weight: 700;
	line-height: 17.5px;
	text-align: left;
	color: #375CAF;
}

.post-smtp-main-wp-wrapper .main-wp-header h3 {
	color: #231F20;
	font-family: Montserrat;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 18.2px */
}

.post-smtp-main-wp-wrapper .main-wp-header h3 span {
	background: linear-gradient(269deg, #3662C7 18.26%, #32B495 47.83%, #B4D859 80.52%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Montserrat;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%;
}

.mobile-unstyles-list li {
	font-family: Montserrat;
	font-size: 11px;
	font-weight: 500;
	line-height: 13.75px;
	text-align: left;
	color: #646464;
	margin-top: 10px;
	list-style: url("../images/marker.svg") inside;
}

.img-wrapper {
	margin-top: 7px;
}

.img-wrapper::after {
	content: "";
	display: table;
	clear: both;
}

.qrcode-img {
	float: left;
	margin-top: 47px;
}

.qrcode-mobile-app {
	float: left;
}

.post-smtp-main-wp-wrapper {
	border-radius: 4px;
	border: 1px solid #DCDFE5;
	background: url( ../images/main-wp-bg.png ), linear-gradient(180deg, #FFF 0%, #EDF2FE 100%);
	padding: 24px 24px;
	background-position: right bottom;
	background-repeat: no-repeat;
}

.main-wp-unstyled-list {
	margin-bottom: 86px;
}

.main-wp-unstyled-list li {
	color: #646464;
	font-family: Montserrat;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13.75px; /* 13.75px */

	list-style: url( ../images/marker-2.svg ) inside;
}

.main-wp-footer a {
	display: inline-flex;
	padding: 10px 20px;
	justify-content: center;
	align-items: center;
	gap: 4px;

	color: #FFF;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px; /* 142.857% */

	border-radius: 50px;
	background: linear-gradient(312deg, #3662C7 21.21%, #32B495 64.57%, #B4D859 112.5%);
	text-decoration: none;
}

.post-smtp-spam-score-wrapper {
	border-radius: 4px;
	border: 1px solid #DCDFE5;
	background: url( ../images/spam-score-bg.png ), linear-gradient(180deg, #FFF 0%, #EDF2FE 100%);
	background-repeat: no-repeat;
	background-position: top right;
	padding: 20px 25px;
}

.post-smtp-spam-score-header h2 {
	color: #231F20;
	font-family: Montserrat;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20.8px; /* 20.8px */
}

.post-smtp-spam-score-header h2 span {
	font-weight: 700;
}

.post-smtp-spam-score-footer a {
	padding: 10px 20px;

	color: #FFF;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 142.857% */

	display: inline-flex;
	justify-content: center;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	background: #375CAF;

	text-decoration: none;
}

.post-smtp-spam-score-list-unstyled {
	margin-bottom: 20px;
}

.post-smtp-spam-score-list-unstyled li {
	color: #646464;
	font-family: Montserrat;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13.75px;

	list-style: url("../images/marker-3.svg") inside;
}
</style>